export default {
  "b2b.konfiguracni-parametry-editace-widget.label.last-modification":
    "Poslední úprava",
  "b2b.konfiguracni-parametry-editace-widget.title":
    "Konfigurační parametry portálu",
  "b2b.konfiguracni-parametry-editace-widget.submit": "Uložit",
  "b2b.konfiguracni-parametry-editace-widget.save-daialog.title":
    "Uložení parametrů portálu"
};
